
import { createAction, handleActions } from 'redux-actions';

// ACTION TYPES
const ATUALIZAR_STORE = `${process.env.PUBLIC_URL}/SERVICOS/ATUALIZAR_STORE`;
const FORMULARIOS_URL_SERVICO = `${process.env.PUBLIC_URL}/FORMULARIOS/URL_SERVICO`;

export const types = {
  ATUALIZAR_STORE,
  FORMULARIOS_URL_SERVICO,
};

// ACTIONS
const atualizarStore = createAction(ATUALIZAR_STORE);
const urlFormularioServico = createAction(FORMULARIOS_URL_SERVICO);

export const actions = {
  atualizarStore,
  urlFormularioServico,
};

// INITIAL STATE
const initialState = {};

// REDUCERS
const reducer = handleActions({
  [ATUALIZAR_STORE]: (state, action) => {
    return { ...state, ...action.payload };
  },
}, initialState);

export default reducer;


// SELECTORS
const getFormularioUrl = (state) => {
  return state.formularios.url || "";
}

export const selectors = {
  getFormularioUrl,
};
